import { Typography } from '@gds/Typography/Typography';

import type { CalculatorMessages } from '../Calculator.messages';

import styles from '../Calculator.module.css';

export type SpecialServiceModalProps = {
  serviceModalStrings: CalculatorMessages;
};

export const SpecialServiceModal = ({ serviceModalStrings }: SpecialServiceModalProps) => {
  return (
    <div className={styles.modalContent} data-test-id="modal-content">
      <div className={styles.modalContentBody} data-test-id="modal-content-body">
        <h3>{serviceModalStrings.additionalContractPrefix}</h3>
        <Typography variant="body3" Component="p">
          {serviceModalStrings.additionalContractDisclaimer}
        </Typography>
        <Typography variant="body3" Component="p">
          {serviceModalStrings.additionalContractDisclaimerTwo}
        </Typography>
      </div>
      <div className={styles.footerContent} data-test-id="footer-content">
        <Typography variant="h6" Component="p">
          {serviceModalStrings.additionalContractFooter}
        </Typography>
        <ul>
          <li>
            <Typography variant="body4" Component="p">
              {serviceModalStrings.additionalContractFooterList}
            </Typography>
          </li>
          <li>
            <Typography variant="body4" Component="p">
              {serviceModalStrings.additionalContractFooterListTwo}
            </Typography>
          </li>
        </ul>
        <Typography variant="h6" Component="p">
          {serviceModalStrings.additionalContractFooterTwo}
        </Typography>
        <ul>
          <li>
            <Typography variant="body4" Component="p">
              {serviceModalStrings.additionalContractDisclaimerThree}
            </Typography>
          </li>
        </ul>
      </div>
    </div>
  );
};
